export default __webpack_public_path__ + "static/clements-e67980325560abac352ebe81478e8161.png";